import React, { useState } from 'react';
import Table from '../../../../../components/Table';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { deleteProperty } from '../../../../../general_redux/rentals/actions';
import { customClassification } from "../../../../../common/functions/utils";
import Loading from '../../../../../components/loading';
import ConfirmMessage from '../../../../../components/Confirmation';

const ViewProperty = (props) => {

  const dispatch = useDispatch();

  const properties = useSelector(({ rentals }) => rentals && rentals.properties);
  const loading = useSelector(({ rentals }) => rentals && rentals.actionForProperty);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [deleteData, setDeleteData] = useState(null);
  const [confirmDel, setConfirmDel] = useState(false);

  const cols = [
    { lable: 'Name', key: 'name' },
    { lable: 'Colour', key: 'color' },
    { lable: 'Address', key: 'street'},
    { lable: 'Actions', key: '' },
  ];
  
  const deletePropertyData = (data) => {
    setDeleteData(data.id);
    setConfirmDel(true);
  };
  const ConfirmedDeleteProperty = () => {
    if (deleteData) {
      dispatch(deleteProperty(deleteData));
      setDeleteData(null);
    }
  };

  return (
    <div>
      <Loading loadingStatus={loading.loading} />
      <ConfirmMessage
        show={confirmDel}
        onHide={() => {
          setConfirmDel(false);
        }}
        confirmHeader={`Delete property`}
        confirmBody={`Deleting this property will delete all rentals, bookings, and
                      information linked to it. It is advisable that you transfer the
                      rentals to another property before proceeding. Are you sure you
                      want to proceed?`
                    }
        onConfirmAct={() => {
          ConfirmedDeleteProperty();
          setConfirmDel(false);
        }}
      />
      <Container fluid>
        <Row className="justify-content-left">
          <Col xs={12} md={8} lg={8} xl={6} className={`p-0 pt-2`}>
            <Table
              isViewProperty={true}
              cols={cols}
              rows={customClassification(properties, order, orderBy)}
              onEdit={props.editProperty}
              onDelete={deletePropertyData}
              order={order}
              setOrder={setOrder}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default ViewProperty;